import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isAfter, startOfDay } from 'date-fns';
import { Observable } from 'rxjs';
import { ParcelaRenegociacaoCartao, StatusPagamentoAcordoRenegociacaoCartaoEnum } from 'src/app/shared/models/acordo-renegociacao-cartao.model';
import { ParcelasCartao } from 'src/app/shared/models/customer-debt-renegociation';

const DisplayStatusMap = {
  PENDENTE: {
    valor: 'PENDENTE',
    descricao: 'Pendente',
  },
  ABERTO: {
    valor: 'ABERTO',
    descricao: 'Em Aberto',
  },
  AGUARDANDO_PGMT: {
    valor: 'AGUARDANDO_PGMT',
    descricao: 'Aguardando Pagamento',
  },
  ATRASADO: {
    valor: 'ATRASADO',
    descricao: 'Atrasado',
  },
}

@Component({
  selector: 'app-acordo-table',
  templateUrl: './acordo-table.component.html',
  styleUrls: ['./acordo-table.component.scss']
})
export class AcordoTableComponent implements OnInit {
  StatusParcelaEnum = StatusPagamentoAcordoRenegociacaoCartaoEnum

  @Output()
  onEmitirBoleto: EventEmitter<ParcelasCartao> = new EventEmitter();

  @Input()
  parcelas: ParcelasCartao[] = [];

  @Input()
  readOnly: boolean;

  @Input()
  acordoAvista: boolean;

  isMobile: Observable<BreakpointState> = this.breakpointObserver.observe('(max-width: 768px)');

  constructor(
    private breakpointObserver: BreakpointObserver,
  ) { }

  ngOnInit(): void {
  }

  handleEmitirBoleto(parcela: ParcelasCartao): void {
    this.onEmitirBoleto.emit(parcela);
  }

  getParcelaStatus(parcela: ParcelasCartao): { valor: string, descricao: string } {
    if (!parcela) {
      return { valor: '', descricao: '' }
    }

    const { valor: status } = parcela.statusPagamento;
    const hoje = startOfDay(new Date());
    const vencimentoParcela = startOfDay(new Date(parcela.dataVencParcela));

    if (isAfter(hoje, vencimentoParcela) && status === StatusPagamentoAcordoRenegociacaoCartaoEnum.ABERTO) {
      return DisplayStatusMap.ATRASADO;
    }

    // Se for a vista, se for a parcela 1 e se estiver em aberto, então mostra o status de aguardando pagamento
    if (this.acordoAvista && parcela.nrParcela === 1 && status === StatusPagamentoAcordoRenegociacaoCartaoEnum.ABERTO) {
      return DisplayStatusMap.AGUARDANDO_PGMT;
    }

    if (status === StatusPagamentoAcordoRenegociacaoCartaoEnum.ABERTO && parcela.linhaDigitavel) {
      return DisplayStatusMap.PENDENTE;
    }

    return parcela.statusPagamento;
  }

}
